import { ErrorMessage } from "@hookform/error-message";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import {
  Card,
  CardBody,
  CardHeader,
} from "reactstrap";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Row,
} from "../../components/Component";
import { GET, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { SETTING_KEY } from "../../utils/Utils";
const Setting = () => {
  const [loading, setLoading] = useState(false);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [warehouseOptions, setWarehouseOptions] = useState([]);

  const formDeliveryFeePerContainer = useForm({
    defaultValues: {
      content: {}
    },
  });


  const formShipFeeSealFeePerContainer = useForm({
    defaultValues: {
      content: 0
    },
  });


  const formShipFeeCustomFee = useForm({
    defaultValues: {
      content: {
        firstContainer: 0,
        restContainer: 0,
      }
    },
  });

  const formCOFee = useForm({
    defaultValues: {
      content: 0
    },
  });

  const formBaseFeeBankFee = useForm({
    defaultValues: {
      content: 0
    },
  });

  const formBaseFeePackageFee = useForm({
    defaultValues: {
      content: 0
    },
  });

  const formBaseFeeShipBuildingFee = useForm({
    defaultValues: {
      content: 0
    },
  });

  const formLiftOffFee = useForm({
    defaultValues: {
      content: 0
    },
  });


  const formInfarstructureFee = useForm({
    defaultValues: {
      content: 0
    },
  });

  const formCustomerHandleCustomFee = useForm({
    defaultValues: {
      content: []
    },
  });


  useEffect(() => {

    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });

    GET("/customer", {}, true).then(({ data }) => {
      setCustomerOptions([
        ...data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        })),
      ]);
    });


    GET("/setting", {}, true).then(({ data }) => {
      data.forEach(({ content, key }) => {


        if (key === SETTING_KEY.DELIVERY_FEE_PER_CONTAINER) {
          formDeliveryFeePerContainer.reset({ content })
        }

        if (key === SETTING_KEY.SHIP_FEE_SEAL_FEE_PER_CONTAINER) {
          formShipFeeSealFeePerContainer.reset({ content })
        }

        if (key === SETTING_KEY.SHIP_FEE_CUSTOM_FEE) {
          formShipFeeCustomFee.reset({ content })
        }

        if (key === SETTING_KEY.CO_FEE) {
          formCOFee.reset({ content })
        }

        if (key === SETTING_KEY.BASE_FEE_BANK_FEE) {
          formBaseFeeBankFee.reset({ content })
        }

        if (key === SETTING_KEY.BASE_FEE_PACKAGE_FEE) {
          formBaseFeePackageFee.reset({ content })
        }

        if (key === SETTING_KEY.BASE_FEE_SHIP_BUILDING_FEE) {
          formBaseFeeShipBuildingFee.reset({ content })
        }

        if (key === SETTING_KEY.LIFT_OFF_FEE) {
          formLiftOffFee.reset({ content })
        }

        if (key === SETTING_KEY.INFARSTRUCTURE_FEE) {
          formInfarstructureFee.reset({ content })
        }

        if (key === SETTING_KEY.INTERNAL_CUSTOMER_HANDLE_CUSTOM_FEE) {
          formCustomerHandleCustomFee.reset({ content })
        }

      })
    })
  }, [])
  // Submits form data
  const onHandleSubmitSetting = ({ content }, key) => {
    setLoading(true);
    PUT(`/setting/${key}`, { content }, {}, true)
      .then(() => {
        toast.success("Cập nhật thành công");
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <React.Fragment>
      <Head title="Cài đặt"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Cài đặt hợp đồng xuất khẩu</BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Row>
          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Giá vận chuyển (đ/cont)
              </CardHeader>
              <CardBody>
                <form onSubmit={formDeliveryFeePerContainer.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.DELIVERY_FEE_PER_CONTAINER))}>
                  <Row className="g-3">
                    <Col md="12">
                      {warehouseOptions.map(({ label, value }) =>
                        <div className="form-group">
                          <label className="form-label" htmlFor="status">
                            {label}<span className="text-danger">*</span>
                          </label>

                          <div className="form-control-wrap">
                            <Controller
                              control={formDeliveryFeePerContainer.control}
                              name={`content.${value}`}
                              rules={{ required: "Vui lòng nhập thông tin" }}
                              render={({ onChange, value, name, ref }) => (
                                <NumericFormat
                                  className="form-control"
                                  getInputRef={ref}
                                  type="text"
                                  value={value}
                                  thousandsGroupStyle="thousand"
                                  thousandSeparator=","
                                  decimalScale={0}
                                  onValueChange={(val) => onChange(val.floatValue)}
                                />
                              )}
                            />
                            <ErrorMessage
                              errors={formDeliveryFeePerContainer.errors}
                              name={`content.${value}`}
                              render={({ message }) => (
                                <span className="invalid">{message}</span>
                              )}
                            />
                          </div>

                        </div>
                      )}

                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Giá seal ($/cont)
              </CardHeader>
              <CardBody>
                <form onSubmit={formShipFeeSealFeePerContainer.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.SHIP_FEE_SEAL_FEE_PER_CONTAINER))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Giá seal <span className="text-danger">*</span>
                        </label>

                        <div className="form-control-wrap">
                          <Controller
                            control={formShipFeeSealFeePerContainer.control}
                            name={`content`}
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formShipFeeSealFeePerContainer.errors}
                            name={`content`}
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>

                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Dịch vụ hải quan (đ/cont)
              </CardHeader>
              <CardBody>
                <form onSubmit={formShipFeeCustomFee.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.SHIP_FEE_CUSTOM_FEE))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Cont đầu <span className="text-danger">*</span>
                        </label>

                        <div className="form-control-wrap">
                          <Controller
                            control={formShipFeeCustomFee.control}
                            name={`content.firstContainer`}
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formShipFeeCustomFee.errors}
                            name={`content.firstContainer`}
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>

                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Cont còn lại <span className="text-danger">*</span>
                        </label>

                        <div className="form-control-wrap">
                          <Controller
                            control={formShipFeeCustomFee.control}
                            name={`content.restContainer`}
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formShipFeeCustomFee.errors}
                            name={`content.restContainer`}
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>

                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Phí CO (đ)
              </CardHeader>
              <CardBody>
                <form onSubmit={formCOFee.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.CO_FEE))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Phí CO<span className="text-danger">*</span>
                        </label>

                        <div className="form-control-wrap">
                          <Controller
                            control={formCOFee.control}
                            name={`content`}
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formCOFee.errors}
                            name={`content`}
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>

                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Phí ngân hàng ($/cont)
              </CardHeader>
              <CardBody>
                <form onSubmit={formBaseFeeBankFee.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.BASE_FEE_BANK_FEE))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Phí ngân hàng<span className="text-danger">*</span>
                        </label>

                        <div className="form-control-wrap">
                          <Controller
                            control={formBaseFeeBankFee.control}
                            name={`content`}
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formBaseFeeBankFee.errors}
                            name={`content`}
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>

                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Phí túi ($/cont)
              </CardHeader>
              <CardBody>
                <form onSubmit={formBaseFeePackageFee.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.BASE_FEE_PACKAGE_FEE))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Phí túi<span className="text-danger">*</span>
                        </label>

                        <div className="form-control-wrap">
                          <Controller
                            control={formBaseFeePackageFee.control}
                            name={`content`}
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formBaseFeePackageFee.errors}
                            name={`content`}
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>

                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Công đóng ($/cont)
              </CardHeader>
              <CardBody>
                <form onSubmit={formBaseFeeShipBuildingFee.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.BASE_FEE_SHIP_BUILDING_FEE))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Công đóng<span className="text-danger">*</span>
                        </label>

                        <div className="form-control-wrap">
                          <Controller
                            control={formBaseFeeShipBuildingFee.control}
                            name={`content`}
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formBaseFeeShipBuildingFee.errors}
                            name={`content`}
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>

                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Phí CSHT (đ/cont)
              </CardHeader>
              <CardBody>
                <form onSubmit={formInfarstructureFee.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.INFARSTRUCTURE_FEE))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Phí CSHT<span className="text-danger">*</span>
                        </label>

                        <div className="form-control-wrap">
                          <Controller
                            control={formInfarstructureFee.control}
                            name={`content`}
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formInfarstructureFee.errors}
                            name={`content`}
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>

                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                Phí hạ (đ/cont)
              </CardHeader>
              <CardBody>
                <form onSubmit={formLiftOffFee.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.LIFT_OFF_FEE))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          Phí hạ<span className="text-danger">*</span>
                        </label>

                        <div className="form-control-wrap">
                          <Controller
                            control={formLiftOffFee.control}
                            name={`content`}
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formLiftOffFee.errors}
                            name={`content`}
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>

                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>

          <Col md={3} className={`mb-3`}>
            <Card>
              <CardHeader className="bg-primary text-white">
                NCC/KH nội bộ làm phí hải quan
              </CardHeader>
              <CardBody>
                <form onSubmit={formCustomerHandleCustomFee.handleSubmit(({ content }) => onHandleSubmitSetting({ content }, SETTING_KEY.INTERNAL_CUSTOMER_HANDLE_CUSTOM_FEE))}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="status">
                          NCC/KH<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={formCustomerHandleCustomFee.control}
                            name="content"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <ReactSelect
                                isMulti
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={customerOptions}
                                value={customerOptions.filter(
                                  (c) => {
                                    return value?.includes(c.value)
                                  }
                                )}
                                onChange={(val) => {
                                  onChange(val.map(e => e.value) || [])
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={formCustomerHandleCustomFee.errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <Button color="primary" type="submit" disabled={loading}>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>

          </Col>
        </Row>
      </Content>
    </React.Fragment>
  );
};

export default Setting;
